<a *ngIf="!isWebView" href="https://play.google.com/store/apps/details?id=com.moglix.tender&hl=en" target="_blank">
  <div class="header-strip" [ngClass]="{ 'd-none': !isStripVisible }">
    <div class="position-relative d-flex app-info-section align-items-center h-100 container-xl">
      <div *ngIf="isBrowser" class="w-100 d-flex app-info-strip  align-items-center">
        <span>10X Faster App Get the improved Experience.</span>
        <img src="./assets/images/googlePlayBadge.webp" alt="get it on google play" />
      </div>
      <i class="sprite-img-header-footer white-circle-cross" (click)="toggleStripHandler();$event.preventDefault()"></i>
    </div>
  </div>
</a>

<nav class="navbar navbar-expand-xl navbar-light main-navbar " [ngClass]="{
    'sticky-header pb-14': isStickyHeaderActive,
    'bg-yellow': currentUrl === '/' || currentUrl === '/pages/download-tender-mobile-app',
    'strip-margin': isStripVisible
  }">

  <div class="flex-nowrap justify-content-between " [ngClass]="{'container-fluid px-50' :  currentUrl !== '/' && currentUrl !== '/pages/download-tender-mobile-app',
    'container-xl' : currentUrl === '/' || currentUrl === '/pages/download-tender-mobile-app'  , }">

    <div class="d-flex">
      <ng-container>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
          (click)="isHumbergerActive = !isHumbergerActive">
          <span class="hamburger" [ngClass]="{ 'is-active': isHumbergerActive }" id="hamburger-1">
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
          </span>
        </button>
      </ng-container>
      <a (click)="navigate(''); $event.preventDefault()" [href]="baseUrl" class="navbar-brand d-flex">
        <img src="https://d1tiqtcifmy0l7.cloudfront.net/prod/icons/Tender_Shark.svg" width="160" height="25"
          alt="TenderShark-Latest Indian Government & Private Tenders, E-Tenders online" Title="TenderShark Logo" />
      </a>
    </div>
    <button type="button" *ngIf="!isLoggedIn" (click)="openModalWithComponent()"
      class="btn pwa-btn-login d-block d-lg-none me-3">
      Login/Signup
    </button>
    <div class="d-block d-lg-none dropdown login-dropdown me-3" *ngIf="isLoggedIn">
      <button class="btn btn-secondary dropdown-toggle" (click)="toggleDropdown()" type="button"
        id="dropdownMenuButton1" aria-expanded="false">
        <i class="sprite-img-header-footer user-profile-icon"></i>
      </button>
      <ul class="dropdown-menu dropdown-menu-end" [class.block]="isOpen" *ngIf="isOpen"
        aria-labelledby="dropdownMenuButton1">
        <li>
          <span class="dropdown-item-text">{{ userdetails.businessName }}</span>
        </li>
        <li>
          <h6 class="dropdown-header">{{ userdetails.gstNum }}</h6>
        </li>
        <li>
          <hr class="dropdown-divider" />
        </li>
        <li>
          <a class="dropdown-item" (click)="logout()">Log Out</a>
        </li>
      </ul>
    </div>

    <div class="collapse navbar-collapse" [ngClass]="{ show: isHumbergerActive }" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto mb-2 mb-xl-0 align-items-center">
        <li class="nav-item">

          <a class="nav-link" [ngClass]="{ active: activeSection === 'keyword_value_tenders' }"
            (click)="navigateTo('/all-tenders/keywords');$event.preventDefault();  isHumbergerActive = !isHumbergerActive"
            [href]="'/all-tenders/keywords'" title="Tender By Keyword"> Tender
            By Keyword</a>
          <!-- <a class="nav-link" [ngClass]="{ active: activeSection === 'keyword_value_tenders' }" (click)="
              navigateTo('/all-tenders/keywords');
              isHumbergerActive = !isHumbergerActive" title="Tender By Keyword">
            Tender By Keyword
          </a> -->
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ active: activeSection === 'authority_tender' }"
            (click)="navigateTo('/all-tenders/authorities');$event.preventDefault();  isHumbergerActive = !isHumbergerActive"
            [href]="'/all-tenders/authorities'" title="Tender By Authority"> Tender
            By Authority</a>

          <!-- <a class="nav-link" [ngClass]="{ active: activeSection === 'authority_tender' }" (click)="
              navigateTo('/all-tenders/authorities');
              isHumbergerActive = !isHumbergerActive
            " title="Tender By Authority">
            Tender By Authority
          </a> -->
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ active: activeSection === 'state_tenders' }"
            (click)="navigateTo('/all-tenders/states'); $event.preventDefault();  isHumbergerActive = !isHumbergerActive"
            [href]="'/all-tenders/states'" title="Tender By States"> Tender
            By States</a>

          <!-- <a class="nav-link" [ngClass]="{ active: activeSection === 'state_tenders' }" (click)="
              navigateTo('/all-tenders/states');
              isHumbergerActive = !isHumbergerActive
            " title="Tender by states">
            Tender by States
          </a> -->
        </li>
        <li class="nav-item" *ngIf="!isLoggedIn">
          <button type="button" (click)="openModalWithComponent()" class="btn btn-danger d-none d-lg-block">
            Login/Signup
          </button>
        </li>

        <li class="nav-item d-none d-lg-block" *ngIf="isLoggedIn">
          <div class="dropdown login-dropdown">
            <button class="btn btn-secondary dropdown-toggle" (click)="toggleDropdown()" type="button"
              id="dropdownMenuButton1" aria-expanded="false">
              <i class="sprite-img-header-footer user-profile-icon"></i>
            </button>

            <ul class="dropdown-menu dropdown-menu-end" [class.block]="isOpen" *ngIf="isOpen"
              aria-labelledby="dropdownMenuButton1">
              <li>
                <span class="dropdown-item-text">{{
                  userdetails.businessName
                  }}</span>
              </li>
              <li>
                <h6 class="dropdown-header">{{ userdetails.gstNum }}</h6>
              </li>
              <li>
                <hr class="dropdown-divider" />
              </li>
              <li>
                <a class="dropdown-item" (click)="logout()">Log Out</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <ng-container *ngIf="showSearchBar">
    <div class="d-flex justify-content-center" *ngIf="currentUrl === '/'">
      <ng-container *ngIf="isStickyHeaderActive">
        <app-search-bar [display]="'mainSearch'" class="search-in-header"></app-search-bar>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="shouldShowTrialBanner">
    <app-subscribe-now-strip [daysLeft]="daysLeft" [ngClass]="{
      'sticky-subscribe-strip': showSearchBar && currentUrl === '/' || currentUrl === '/pages/download-tender-mobile-app', 'sticky-subscribe-strip-2':isStickyHeaderActive}" />
  </ng-container>
  
</nav>

<ng-container *ngIf="showSearchBarInListing">
  <app-search-bar [display]="'mainSearch'"></app-search-bar>
</ng-container>

<div *ngIf="isModalvis">
  <!-- <app-signup></app-signup> -->
  <app-signin-with-otp></app-signin-with-otp>
</div>

<div>
  <app-download-popup></app-download-popup>
</div>
<div>
  <rating-popup></rating-popup>
</div>
<!-- <app-signup></app-signup> -->